import { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminDashboardVideos() {
  const [videos, setVideos] = useState([]);
  const [categories, setCategories] = useState([]);

  // فیلدهای فرم
  const [title, setTitle] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [publishDate, setPublishDate] = useState('');
  const [editingId, setEditingId] = useState(null);

  // گرفتن ویدئوها
  useEffect(() => {
    (async () => {
      const { data } = await axios.get('/api/videos');
      setVideos(data);
    })();
  }, []);

  // گرفتن دسته‌بندی‌های ویدئو
  useEffect(() => {
    (async () => {
      const { data } = await axios.get('/api/video-categories');
      setCategories(data);
    })();
  }, []);

  async function addVideo(e) {
    e.preventDefault();
    const { data } = await axios.post('/api/videos', {
      title, youtubeUrl, description, category, publishDate
    });
    setVideos(prev => [...prev, data]);
    resetForm();
  }

  async function updateVideo(id) {
    const { data } = await axios.put(`/api/videos/${id}`, {
      title, youtubeUrl, description, category, publishDate
    });
    setVideos(prev => prev.map(v => v._id === id ? data : v));
    resetForm();
  }

  async function deleteVideo(id) {
    await axios.delete(`/api/videos/${id}`);
    setVideos(prev => prev.filter(v => v._id !== id));
  }

  function resetForm() {
    setTitle('');
    setYoutubeUrl('');
    setDescription('');
    setCategory('');
    setPublishDate('');
    setEditingId(null);
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Manage Videos</h1>

      {/* فرم افزودن/ویرایش */}
      <form onSubmit={editingId ? (e) => { e.preventDefault(); updateVideo(editingId); } : addVideo} className="mb-4">
        <input
          className="form-control mb-2"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <input
          className="form-control mb-2"
          placeholder="YouTube URL"
          value={youtubeUrl}
          onChange={e => setYoutubeUrl(e.target.value)}
        />
        <textarea
          className="form-control mb-2"
          placeholder="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />

        <select
          className="form-select mb-2"
          value={category}
          onChange={e => setCategory(e.target.value)}
        >
          <option value="">Select Video Category</option>
          {categories.map(c => (
            <option key={c._id} value={c.name}>{c.name}</option>
          ))}
        </select>

        <input
          type="date"
          className="form-control mb-2"
          value={publishDate}
          onChange={e => setPublishDate(e.target.value)}
        />

        {editingId ? (
          <button className="btn btn-warning">Update Video</button>
        ) : (
          <button className="btn btn-success">Add Video</button>
        )}
        {editingId && (
          <button type="button" className="btn btn-secondary ms-2" onClick={resetForm}>
            Cancel
          </button>
        )}
      </form>

      {/* لیست ویدئوها */}
      <ul className="list-group">
        {videos.map(v => (
          <li key={v._id} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <strong>{v.title}</strong><br />
              <small className="text-muted">
                Category: {v.category} | Published: {v.publishDate ? new Date(v.publishDate).toLocaleDateString() : 'N/A'}
              </small>
            </div>
            <div>
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  setTitle(v.title);
                  setYoutubeUrl(v.youtubeUrl);
                  setDescription(v.description);
                  setCategory(v.category);
                  setPublishDate(v.publishDate?.slice(0,10));
                  setEditingId(v._id);
                }}
              >
                Edit
              </button>
              <button className="btn btn-sm btn-danger" onClick={() => deleteVideo(v._id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
